<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :table-data="getData"
          :total-data="totalRows"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="customerForm"
          :redirect-detail="false"
          :show-add-button="false"
          :search-by-lead-date="true"
          caption="<i class='fa fa-align-justify'></i> Logs Listing"
          addButton="Tambah Customer"
          @editForm="editForm"
        ></global-table>
      </b-col>
    </b-row>

      <b-modal
        ref="myModalRef"
        id="addModals"
        header-border-variant="no-border text-center"
        footer-border-variant="no-border"
        footer-bg-variant="light"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        hide-footer
        size="lg"
      >
        <div slot="modal-header" class="text-center">
          <h3 class="text-center">Data yang di ubah</h3>
        </div>

        <b-form id="employeeForm" validated novalidate>
          <div v-if="!loadingSubmit">
            <b-row>
              <b-col sm="12">
                 <template>
                    <table class="table-auto w-full border-collapse border border-gray-400" style="width: 100%">
                      <thead>
                        <tr class="bg-gray-200">
                          <th class="border px-2 py-1 text-left">Field</th>
                          <th class="border px-2 py-1 text-left">Old Value</th>
                          <th class="border px-2 py-1 text-left">New Value</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, key) in show" :key="key">
                          <td class="border px-2 py-1">{{ key }}</td>
                          <td class="border px-2 py-1 text-gray-500">
                            {{ item.old  }}
                          </td>
                          <td class="border px-2 py-1 text-green-700 font-semibold">
                            {{ item.new }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                </template>
              </b-col>
            </b-row>
            <div class="float-right">
              <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
                <i class="fa fa-undo"></i> Back
              </b-button>&nbsp;
             
            </div>
          </div>
          <div v-else>
            <loading></loading>
          </div>
        </b-form>
      </b-modal>
  </div>
</template>


<script>
import axios from "axios";
import globalTable from "../../templates/TableNew.vue";
import interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "leads",
  components: { globalTable, ModelSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      leads: [],
      customerForm: interfaces.employee,
      loading: true,
      loadingSubmit: false,
      totalRows: "",
      show: [],
      fields: [
        {
          key: "nik",
          label: "NIK",
          sortable: true,
          class: "width-150",
          filterByFormatted: true,
        },
        {
          key: "name",
          label: "Nama Karyawan",
          class: "width-200",
          sortable: true,
          filterByFormatted: true,
        },
        {
          key: "activity",
          label: "Aktivitas",
          class: "width-250",
          sortable: false,
          filterByFormatted: false,
        },
        {
          key: "action_menu",
          label: "Menu",
          class: "width-250",

          sortable: false,
          filterByFormatted: false,
        },
        {
          key: "date_inserted",
          label: "Tanggal",
          sortable: false,
          class: "width-150",

          filterByFormatted: false,
        },
        { key: "action", class: "text-center width-80" },
      ],
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },

  methods: {
    getData: function (ctx) {
      this.loading = true;
      let response = axios.post("web/employee/logs-all", ctx);
      return response
        .then((data) => {
          const items = data.data.data;
          this.totalRows = data.data.total_rows;
          this.loading = false;
          return items;
        })
        .catch((error) => {
          this.expired(error);
          this.loading = false;
          return [];
        });
    },
    editForm: function (row) {
        this.show = row.differences;
        console.log(this.show);
    },
    cancelAdd: function() {
      this.isEdit = false;
      this.$refs.myModalRef.hide();
      this.show = [];
    },
    expired: function (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: "Tambah Karyawan",
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    //this.init();
  },
};
</script>